export const appInfo = {
  name: 'PRIZM WMS Mobile',
  shortName: 'PRIZM WMS',
  version: '3.6.0',
  defaultLanguage: 'en' as const,
  supportedLanguages: ['es', 'en'] as const,
  defaultTheme: 'light' as const,
};
